// extracted by mini-css-extract-plugin
export default {"root":"qrcode_root__CD823","qr":"qrcode_qr__kfIQt","expandIcon":"qrcode_expandIcon__rdk9F","fullscreen":"qrcode_fullscreen__DgMCm"};